'use client';
import { useCallback, useEffect, useState } from 'react';
import type { RoomControls, RoomEvents } from '@huddle01/web-core/types';
import useHuddle01 from './useHuddle01';

export const useRoomControls = (props?: {
  onRoomControlsUpdated: (data: RoomControls) => void;
  onRoomLeave: (data: RoomEvents['room-closed'][0]) => void;
}) => {
  const { huddleClient } = useHuddle01();

  const room = huddleClient.room;

  const [roomControls, setRoomControls] = useState<RoomControls>(room.config);

  const handleRoomClose = useCallback(
    (data: RoomEvents['room-closed'][0]) => {
      if (props?.onRoomLeave) props.onRoomLeave(data);
    },
    [props?.onRoomLeave],
  );

  const handleRoomControlsUpdate = useCallback(() => {
    if (props?.onRoomControlsUpdated) props.onRoomControlsUpdated(room.config);

    setRoomControls(room.config);
  }, [props?.onRoomControlsUpdated]);

  useEffect(() => {
    room.once('room-closed', handleRoomClose);

    room.on('room-controls-updated', handleRoomControlsUpdate);

    return () => {
      room.off('room-closed', handleRoomClose);

      room.off('room-controls-updated', handleRoomControlsUpdate);
    };
  }, []);

  const updateControls = room.updateRoomControls;

  return {
    roomControls,
    updateControls,
  };
};
